"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Button.css");
var Utils = require("player-core/utils");
// 'ButtonProps' describes the shape of props.
var Button = (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this._onClick = _this._onClick.bind(_this);
        _this.enableButton = _this.enableButton.bind(_this);
        _this.preventDoubleClick = _this.preventDoubleClick.bind(_this);
        _this._Id = _this.props.id || Utils.createUUID();
        _this.state = { isDisabled: false };
        return _this;
    }
    /* istanbul ignore next */
    Button.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeout);
    };
    Button.prototype._onClick = function (event) {
        this.preventDoubleClick();
        if (!this.props.isDisabled && this.props.onClick) {
            this.props.onClick(event);
        }
    };
    Button.prototype.preventDoubleClick = function () {
        this.setState({ isDisabled: true });
        this.timeout = window.setTimeout(this.enableButton, 200);
    };
    /* istanbul ignore next */
    Button.prototype.enableButton = function () {
        this.setState({ isDisabled: false });
    };
    Button.prototype.render = function () {
        var _a = this.props, type = _a.type, color = _a.color, width = _a.width, isDisabled = _a.isDisabled, iconName = _a.iconName, iconRotation = _a.iconRotation, iconPosition = _a.iconPosition, text = _a.text, useSpanElement = _a.useSpanElement, toolTip = _a.toolTip, maxWidth = _a.maxWidth, sharpCorners = _a.sharpCorners, truncation = _a.truncation, title = _a.title, shouldFlipForRtl = _a.shouldFlipForRtl, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy;
        var cssClass = ['p-button'];
        var tagAttr = {};
        cssClass.push((type === 'Borderless') ? 'borderless' : 'basic');
        if (color) {
            cssClass.push(color.toLowerCase());
        }
        /* istanbul ignore else */
        if (width) {
            var cases = {
                'Xsmall': 'width-xsmall',
                'Small': 'width-small',
                'Medium': 'width-medium',
                'Large': 'width-large',
                'Auto': 'width-auto',
                'Block': 'width-block'
            };
            cssClass.push(cases[width] ? cases[width] : cases['Auto']);
        }
        if (truncation) {
            cssClass.push('p-truncation');
        }
        var accessibilityAttr = {};
        if (isDisabled || this.state.isDisabled) {
            cssClass.push('is-disabled');
            accessibilityAttr['aria-disabled'] = true;
        }
        /* istanbul ignore else */
        if (sharpCorners && sharpCorners.length) {
            sharpCorners.forEach(function (side) {
                cssClass.push("p-sharp-" + side);
            });
        }
        var iconClasses = [];
        if (iconName) {
            iconClasses.push('p-icon-' + iconName.toLowerCase());
        }
        if (iconRotation) {
            iconClasses.push('p-rotate-' + iconRotation.toLowerCase());
        }
        if (shouldFlipForRtl) {
            iconClasses.push('p-rtl-flip');
        }
        if (this.props.tag != null) {
            tagAttr['data-tag'] = this.props.tag;
        }
        var El = useSpanElement ? 'span' : 'button';
        var buttonProps = {
            id: this._Id,
            className: cssClass.join(' '),
            onClick: this._onClick,
            title: toolTip,
            disabled: isDisabled || this.state.isDisabled
        };
        if (El === 'button') {
            buttonProps['type'] = 'button';
        }
        else {
            buttonProps['role'] = 'button';
            buttonProps['aria-disabled'] = isDisabled || this.state.isDisabled;
            buttonProps['tabIndex'] = 0;
        }
        if (maxWidth) {
            buttonProps['style'] = { maxWidth: maxWidth };
        }
        if (title) {
            buttonProps['title'] = title;
        }
        if (ariaLabel) {
            buttonProps['aria-label'] = ariaLabel;
        }
        if (ariaDescribedBy) {
            buttonProps['aria-describedby'] = ariaDescribedBy;
        }
        var content = ([
            (iconName ? React.createElement("span", { key: 'button-icon', className: iconClasses.join(' ') }) : null),
            ' ',
            (text ? React.createElement("span", { key: 'button-text', className: "p-button-text" }, text) : null)
        ]);
        return (React.createElement(El, __assign({}, this.props.attributes, buttonProps, accessibilityAttr, tagAttr), iconPosition === 'Right' ? content.reverse() : content));
    };
    return Button;
}(React.Component));
Button.defaultProps = {
    id: '',
    text: '',
    type: 'Default',
    color: 'Primary',
    width: 'Auto',
    iconName: null,
    iconRotation: '',
    iconPosition: 'Left',
    toolTip: '',
    isDisabled: false,
    useSpanElement: false,
    onClick: void (0),
    maxWidth: 'Auto',
    tag: null,
    sharpCorners: [],
    attributes: {},
    truncation: false,
    title: '',
    shouldFlipForRtl: false,
    ariaLabel: null,
    ariaDescribedBy: null
};
exports.default = Button;
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// ../player-button/build/control/Button.js
// module id = 548
// module chunks = 0